// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsie-editor-continer {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 241, 196, 0.644);
  border: rgba(250, 230, 117, 0.527);
  border-width: 5px;
  border-style: solid;
  border-radius: 5px;
  height: 100%;
}

.top-row-buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 5px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsieEditor.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb","sourcesContent":[".newsie-editor-continer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: rgba(255, 241, 196, 0.644);\n  border: rgba(250, 230, 117, 0.527);\n  border-width: 5px;\n  border-style: solid;\n  border-radius: 5px;\n  height: 100%;\n}\n\n.top-row-buttons-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
